<script>
    const uuidv1 = require('uuid/v1');
    import DeleteIcon from 'vue-material-design-icons/Delete.vue';
    

    export default {
        components: {
            DeleteIcon
        },      
        props: ['educator', 'editable'],
        async mounted () {   
            this.courseModels = await this.$store.getters.getCourses  
            this.allGradeLevels = await this.$store.getters.allGradeLevels          
        },
        data() {
            return {
                editing: false,
                renderClassModal: true
            }
        },
        filters: {
          capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
          }
        },          
        methods: { 
          toggleGradeFlag( flag ){

            flag.active = !flag.active
            console.log( "gradeStruct updated: " + JSON.stringify(flag))
            console.log(JSON.stringify(this.educator.courses))
          },
          lowerCaseIt( str ) {
            return str.toLowerCase()
          },    
          dismiss() {
            this.educator = this.beforeEdit
            this.editing = false;
          },
          openModal() {
            this.beforeEdit = JSON.parse(JSON.stringify(this.educator))
            this.editing = true
          },
          save() {
            //this.educator.description = this.desc
            console.log("emitting save for courses")
            this.$emit('save')
            this.editing=false
          },
          addClass() {
            if ( !this.educator.courses ) {
              this.educator.courses = {}
            }
            var courseList = this.educator.courses // replace later with temp
            var courseKey = uuidv1() //new Date().getTime().toString()
            var courseStruct = {}
            courseStruct.courseName = ""

            courseStruct.gradeFlags = []
            var gradeName = ""
            for ( var n = 0; n < this.allGradeLevels.length; n++ ) {

                gradeName = this.allGradeLevels[n]
                var newThing = { gradeLabel: gradeName, active: false }
                courseStruct.gradeFlags.push(newThing)
                
            }

            courseList[ courseKey ] = courseStruct

            this.refreshModal()           
            
          },
          deleteClass(key) {
            if ( confirm("Delete this class?") ) {
              delete this.educator.courses[ key ]
              this.refreshModal()
            }
          },
          refreshModal(){
            this.renderClassModal = false
            this.$nextTick(() => {
              this.renderClassModal = true
            }); 
          },
          convertDataForSaving() {
            var courseName = ""
            var levelArray = []
            var courseStructRef = ""
            var gradeName = ""
            var grades = ""

            var courseNameArray = []
            if ( this.educator.courses ) {
              courseNameArray = Object.keys(this.educator.courses);
            }

            var courseGradesTaughtArray = []
            console.log('hi')



            for ( var i = 0; i < courseNameArray.length; i++ ) {
              courseName = courseNameArray[i]
              courseStructRef = this.educator.courses[ courseName ]

              var newCourseStructData = {}
              var idx = 0
              for ( var x = 0; x < courseStructRef.gradeFlagHashArray.length; x++ ) {
                var gradeStruct = courseStructRef.gradeFlagHashArray[x]
                if ( gradeStruct.active == true ) {
                  newCourseStructData[idx] = gradeStruct.gradeLabel
                  idx++
                }
              }
              courseStructRef.grades = newCourseStructData
            }
          }
        }
        
    }
</script>



<template lang="pug">

.foo
  #curr.z-depth-1
    .row
      .row.edit-div(v-if="editable")
        .col.s12.right-align
          img.edit-icon.modal-trigger(
          data-target='educ-courses-modal' 
          src='@/assets/svg/Asset15.svg'
          @click="openModal" )
      .curr-container
        .row  
          h6 Current Class Information
          //Edit information if user has no courses
          .col.s12.hide#no-courses.edit-div(v-if="!educator.courses && editable")
            img.edit-icon.modal-trigger(
            data-target='educ-courses-modal' 
            src='@/assets/svg/Asset14.svg' 
            @click="openModal"
            )
            span
              |  Add information about what classes you teach!
        .row
          #curr-courses
            .row( v-for="( courseStruct, key ) in educator.courses")
              .course.col.s6
                p 
                  | {{courseStruct.courseName}}
                  span(v-if="courseStruct.courseName=='Other'") &nbsp;({{courseStruct.otherText}})
              .grade.col.s4.offset-s1
                .gradeContainer
                  .gradeListLabel( v-for="(grade, index) in courseStruct.gradeFlags" v-if="grade.active" )
                    span.gradeLabel {{ grade.gradeLabel | capitalize }}

  #educ-courses-modal(v-if="editing")
    .modal-overlay2(@click="dismiss")
      .modal-content.class-modal( @click.stop="" )
        .row
          .modal-hdr.col.s12.no-padding
            h6 Current Class Information
            hr
            //- DO NOT REMOVE! re-rendering "add class" didn't work until I added this.  weird              
            p(v-if="renderClassModal") &nbsp;  
        #course-template
          p What courses do you teach? Add them here.
          .template-row( v-for="( courseStruct, key ) in educator.courses" v-if="renderClassModal")
            .row
              .col.s8.offset-s1.input-field
                //label.active Add Course
                select.educ-course(v-model="courseStruct.courseName")
                  option(value="" disabled) Select Course
                  option(v-for="label in courseModels" :value="label") {{label}}
                p(v-if="courseStruct.courseName == 'Other'")
                  input.other-text(type='text' placeholder="Fill in Subject Here" v-model="courseStruct.otherText")
              .col.s2
                //- i.curr-icon.material-icons.menu(@click="deleteClass(key)") clear
                delete-icon.delete-class(@click="deleteClass(key)")
            .row
              .col.s11.offset-s1.m8.offset.m2
                .grade-checkbox(v-for="gradeStruct in courseStruct.gradeFlags")
                  label.gradeCheckLabel {{gradeStruct.gradeLabel | capitalize}}
                  input.gradeCheck(type="checkbox"
                    true-value="yes"
                    false-value="no"
                    :checked="gradeStruct.active"
                    v-bind="gradeStruct"
                    @click="toggleGradeFlag(gradeStruct)"
                  )
            hr.margin-top-hr

        .row
          .col.s5.offset-s1
            a.btn-floating.btn-medium.waves-effect.waves-light.orange#add-course
              #add-course-icon.material-icons(@click="addClass()") +
            #add-course-text(@click="addClass()")  Add another class
          .col.s5.right-align.close-btn-div
            button.close-btn.modal-close#save-courses-info(type='button' @click="save") SAVE
          .col.s1
          .col.s5.offset-s6.right-align.close-btn-div
            button.close-btn.modal-close(type='button' @click="dismiss") CANCEL          




</template>



<style lang="sass" scoped>

#curr
  padding: .5em

#add-course-icon
  text-align: center;
  font-size: 2.5em;
  line-height: 100%;
  cursor:pointer

#add-course-text
  cursor: pointer

.gradeCheckLabel
  font-size: .8em
  position: relative
  top: 2px
  color: black


.class-modal
  width: 60%

@media screen and (max-width: 800px)
  .class-modal
    width: 95%



.delete-class
  font-size: 2em
  cursor: pointer

.delete-class:hover
  color: red 

.gradeContainer
  padding-top: 15px
  padding-bottom: 15px
  padding-left: 5px
  float: left

.gradeLabel
  border: thin solid gray
  border-radius: 5px
  padding: 2px 3px 2px 3px
  margin-right: 5px
  -webkit-box-shadow: -2px 2px 4px -2px rgba(0,0,0,0.75);
  -moz-box-shadow: -2px 2px 4px -2px rgba(0,0,0,0.75);
  box-shadow: -2px 2px 4px -2px rgba(0,0,0,0.75);

.gradeListLabel
  float: left

.grade-checkbox
  float: left
  font-size: 1.5em
  padding: 5px 15px 5px 5px;  
  label
    padding-right: 5px;


#curr
  margin-top: 2em

input
  opacity: 100 !important
  position: relative !important
  pointer-events: all !important


select
  display: block



.no-content
  font-size: .8em

/*****************************************/
//introduction css
/*****************************************/

#info 
  margin-top: 1em;
  padding: .5em;
  background-color: #fff;


#info, #opps 
  padding: .5em;


#info h6, #opps h6 
  //margin-top: -10px;
  font-size: 20px;
  margin-bottom: 10px;
  font-weight: normal;



#no-info span, #no-opps span 
  font-size: 12px;
  color: #bbbbbb;


#no-info img 
  margin: 0;


// /*****************************************/
// // intro box css
// /*****************************************/

#intro pre 
  margin: 0;


#company-intro 
  border: 1px black solid;
  padding-left: .25em !important;
  height: 300px !important;



</style>